type LogLevel = 'debug' | 'info' | 'warn' | 'error'

interface LogOptions {
  level: LogLevel
  context?: string
  data?: any
}

const isDevelopment = process.env.NODE_ENV === 'development'

export const logger = {
  debug: (message: string, context?: string, data?: any) => {
    if (isDevelopment) {
      log({ level: 'debug', context, data }, message)
    }
  },

  info: (message: string, context?: string, data?: any) => {
    log({ level: 'info', context, data }, message)
  },

  warn: (message: string, context?: string, data?: any) => {
    log({ level: 'warn', context, data }, message)
  },

  error: (message: string, context?: string, data?: any) => {
    log({ level: 'error', context, data }, message)
  },

  http: (method: string, url: string, status?: number, data?: any) => {
    const context = 'HTTP'
    const message = `${method} ${url} ${status ? `(${status})` : ''}`
    log({ level: 'debug', context, data }, message)
  }
}

function log(options: LogOptions, message: string) {
  const timestamp = new Date().toISOString()
  const prefix = options.context ? `[${options.context}]` : ''
  
  const style = getLogStyle(options.level)
  
  // Format the log message
  const logMessage = `${timestamp} ${prefix} ${message}`

  switch (options.level) {
    case 'debug':
      console.debug(`%c${logMessage}`, style, options.data || '')
      break
    case 'info':
      console.info(`%c${logMessage}`, style, options.data || '')
      break
    case 'warn':
      console.warn(`%c${logMessage}`, style, options.data || '')
      break
    case 'error':
      console.error(`%c${logMessage}`, style, options.data || '')
      if (options.data instanceof Error) {
        console.error(options.data.stack)
      }
      break
  }
}

function getLogStyle(level: LogLevel): string {
  switch (level) {
    case 'debug':
      return 'color: #6B7280' // gray
    case 'info':
      return 'color: #3B82F6' // blue
    case 'warn':
      return 'color: #F59E0B' // yellow
    case 'error':
      return 'color: #EF4444' // red
    default:
      return ''
  }
}